import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
import { paymentState, listTerms, listUserGroups, orderStatus, getOrderStatusIcon, defaultPagingChoices, expeditionMethods, expeditionMethodList, emptyCellContent } from "@/js/lists.ts";
import { isHolding } from "@/js/http/auth.js";
import { getOrderConfirmationReference } from "@/js/order/order.js";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import { getFullNameUserHtml, userGroupName } from "@/js/user/user.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ImportOrderDialogVue from "@/components/order/ImportOrderDialog.vue";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import ContextMenu from "@/components/context-menu/ContextMenu.vue";
export default {
  name: "ConsultantOrderList",
  components: {
    Confirm: Confirm,
    ImportOrderDialogVue: ImportOrderDialogVue,
    paging: pagingComponent,
    index: indexComponent,
    ContextMenu: ContextMenu
  },
  props: {
    loggedUserData: Object,
    filters: {
      default: false
    }
  },
  data: function data(_this) {
    return {
      headers: [{
        text: "N°",
        value: "referenceOrder",
        align: "left",
        width: "130px",
        cellClass: "text-nowrap"
      }, {
        text: "Customer",
        value: "customer",
        align: "center",
        width: "200px"
      }, {
        text: "Status",
        value: "status",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "",
        value: "isFullyCalculatedAmounts",
        align: "center"
      }, {
        text: "Amount",
        value: "amount",
        align: "end",
        cellClass: "text-nowrap"
      }, {
        text: "Delivery address",
        value: "deliveryAddress",
        align: "start"
      }, {
        text: "Shipping type",
        value: "shipmentMethod",
        align: "start",
        cellClass: "text-nowrap"
      }, {
        text: "Order Date",
        value: "orderDate",
        align: "center"
      }, {
        text: "Delivery Date",
        value: "deliveryDate",
        align: "center"
      }],
      isImportOrderShown: false,
      updatingOrderStatus: false,
      baseModel: {
        orders: [],
        numberOfOrders: 0,
        numberOfPages: 0
      },
      formSearch: {
        label: "",
        paymentStates: [],
        excludeWineDetails: true,
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        },
        sort_by: null,
        range_date: []
      },
      searchLabelLastUsed: null,
      dataLoading: true,
      pagingLimitsChoices: defaultPagingChoices,
      sortBy: [{
        id: "ASCENDING_DATE",
        label: "Ascending date"
      }, {
        id: "DESCENDING_DATE",
        label: "Descending date"
      }, {
        id: "RANGE_DATE",
        label: "Range dates"
      }],
      isCopyingToClipboard: false,
      rangeDatesDisplay: [],
      sortByRangeDatesMenu: false,
      updateOrdersMenus: {},
      updateOrdersStatus: [],
      hover: false,
      listTerms: listTerms,
      listUserGroups: listUserGroups,
      expeditionMethods: expeditionMethods,
      expeditionMethodList: expeditionMethodList,
      emptyCellContent: emptyCellContent,
      paymentState: paymentState,
      orderStatus: orderStatus
    };
  },
  computed: {
    filterByOrderStatusAllowed: function filterByOrderStatusAllowed() {
      return orderStatus.filter(function (os) {
        return os.id !== "CREATED";
      });
    },
    isFilteringStatus: function isFilteringStatus() {
      return this.isFilteringToValidate || this.isFilteringInPreparation || this.isFilteringInTransit || this.isFilteringHeld || this.isFilteringDelivered || this.isFilteringInbound || this.isFilteringCancelled;
    },
    isFilteringToValidate: function isFilteringToValidate() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "ADJUSTING" || x.id == "AWAITING_CUSTOMER_VALIDATION" || x.id == "AWAITING_VALIDATION";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringToConsolidate: function isFilteringToConsolidate() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "VALIDATED";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringToShip: function isFilteringToShip() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "IN_PREPARATION";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringInPreparation: function isFilteringInPreparation() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "VALIDATED" || x.id == "IN_PREPARATION";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringInTransit: function isFilteringInTransit() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "DELIVERY" || x.id == "CUSTOMS_CLEARANCE";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringHeld: function isFilteringHeld() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "ON_HOLD";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringDelivered: function isFilteringDelivered() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "DELIVERED";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringInbound: function isFilteringInbound() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "INBOUND" || x.id == "SUBCONTAINER_PUT_INBOUND";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringCancelled: function isFilteringCancelled() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "CANCELLED";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    canImportOrder: function canImportOrder() {
      return this.$whitelabel.isExportPriceList;
    },
    canAccessInbound: function canAccessInbound() {
      return isHolding(this.loggedUserData);
    }
  },
  created: function created() {
    this.formSearch.status_allowed = this.filterByOrderStatusAllowed.filter(function (x) {
      return x.id != "INBOUND" && x.id != "SUBCONTAINER_SUB_INBOUND" && x.id != "CANCELLED";
    }).map(function (x) {
      return x.id;
    });
    var filters = getFilters();
    if (filters !== null && filters !== void 0 && filters.orders) {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), filters.orders);
    }
  },
  mounted: function mounted() {
    this.search(true);
  },
  methods: {
    clearFiltersStatus: function clearFiltersStatus() {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
        status_allowed: []
      });
      this.search(true);
    },
    fillFiltersStatus: function fillFiltersStatus() {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
        status_allowed: this.filterByOrderStatusAllowed.map(function (x) {
          return x.id;
        })
      });
      this.search(true);
    },
    isGreatExport: function isGreatExport(order) {
      var _order$delivery_addre;
      return !(order !== null && order !== void 0 && (_order$delivery_addre = order.delivery_address) !== null && _order$delivery_addre !== void 0 && (_order$delivery_addre = _order$delivery_addre.country) !== null && _order$delivery_addre !== void 0 && _order$delivery_addre.european_union_member);
    },
    isInDelivery: function isInDelivery(order) {
      return orderStatus.find(function (os) {
        return os.id === "DELIVERY";
      }).status === order.status;
    },
    isShipped: function isShipped(order) {
      return orderStatus.filter(function (x) {
        return ["DELIVERY", "CUSTOMS_CLEARANCE", "INBOUND", "SUBCONTAINER_PUT_INBOUND", "DELIVERED"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(order.status);
    },
    isInvoiceConsultable: function isInvoiceConsultable(order) {
      var _order$importer;
      return order.isInvoiced && (!isHolding(this.loggedUserData) || !((_order$importer = order.importer) !== null && _order$importer !== void 0 && _order$importer.id)) && (this.isShipped(order) || order.status == orderStatus.find(function (os) {
        return os.id === "CANCELLED";
      }).status);
    },
    isImporterInvoiceConsultable: function isImporterInvoiceConsultable(order) {
      return order.isImporterInvoiced && (this.isShipped(order) || order.status == orderStatus.find(function (os) {
        return os.id === "CANCELLED";
      }).status);
    },
    clearDateRange: function clearDateRange() {
      this.formSearch.range_date = [];
      this.search(true);
    },
    changeFilterBy: function changeFilterBy() {
      this.formSearch.paging = {
        limits: 24,
        currentPage: 0,
        askedPage: 0
      };
      this.search(true);
    },
    fastFilter: function fastFilter(type) {
      this.formSearch.paging = {
        limits: 24,
        currentPage: 0,
        askedPage: 0
      };
      switch (type) {
        case "to_validate":
          if (this.isFilteringToValidate) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "AWAITING_CUSTOMER_VALIDATION" && id !== "AWAITING_VALIDATION" && id !== "ADJUSTING";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "AWAITING_CUSTOMER_VALIDATION" && id !== "AWAITING_VALIDATION" && id !== "ADJUSTING";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id == "AWAITING_CUSTOMER_VALIDATION" || x.id == "AWAITING_VALIDATION" || x.id == "ADJUSTING";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "to_consolidate":
          if (this.isFilteringToConsolidate) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "VALIDATED";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "VALIDATED";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "VALIDATED";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "to_ship":
          if (this.isFilteringToShip) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "IN_PREPARATION";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "IN_PREPARATION";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "IN_PREPARATION";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "in_preparation":
          if (this.isFilteringInPreparation) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "VALIDATED" && id !== "IN_PREPARATION";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "VALIDATED" && id !== "IN_PREPARATION";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id == "VALIDATED" || x.id == "IN_PREPARATION";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "held":
          if (this.isFilteringHeld) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "ON_HOLD";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "ON_HOLD";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "ON_HOLD";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "in_transit":
          if (this.isFilteringInTransit) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "DELIVERY" && id !== "CUSTOMS_CLEARANCE" && id !== "SUBCONTAINER_CONTAINER_IN_TRANSIT";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "DELIVERY" && id !== "CUSTOMS_CLEARANCE" && id !== "SUBCONTAINER_CONTAINER_IN_TRANSIT";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id == "DELIVERY" || x.id == "CUSTOMS_CLEARANCE" || x.id == "SUBCONTAINER_CONTAINER_IN_TRANSIT";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "delivered":
          if (this.isFilteringDelivered) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "DELIVERED";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "DELIVERED";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "DELIVERED";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "inbound":
          if (this.isFilteringInbound) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "INBOUND" && id !== "SUBCONTAINER_PUT_INBOUND";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "INBOUND" && id !== "SUBCONTAINER_PUT_INBOUND";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "INBOUND" || x.id === "SUBCONTAINER_PUT_INBOUND";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "cancelled":
          if (this.isFilteringCancelled) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "CANCELLED";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "CANCELLED";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "CANCELLED";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
      }
      this.changeFilterBy();
    },
    changeSortBy: function changeSortBy() {
      if (this.sortBy.find(function (x) {
        return x.id === "RANGE_DATE";
      }).id !== this.formSearch.sort_by) {
        this.search(true);
      }
    },
    sortByDatesRanges: function sortByDatesRanges() {
      if (this.formSearch.range_date.length >= 2) {
        this.sortByRangeDatesMenu = false;
        this.search(true);
      }
    },
    formatDates: function formatDates() {
      var formatedDates = [];
      this.formSearch.range_date.forEach(function (date) {
        formatedDates.push(new Date(date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        }));
      });
      this.rangeDatesDisplay = formatedDates;
    },
    resetPaging: function resetPaging() {
      this.formSearch.paging.askedPage = 0;
    },
    search: function search() {
      var _this2 = this;
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$EventBus.$emit("loading", true);
      this.dataLoading = true;
      var _this = this;
      if (isResetPaging) _this.resetPaging();
      setFilters(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          orders: _this2.formSearch
        });
      });
      _this.searchLabelLastUsed = _this.formSearch.label;
      return request("/v1/orders", "post", _this.formSearch, true, "api").then(function (response) {
        window.scrollTo({
          top: 0
        });
        _this.baseModel.orders.splice(_this.formSearch.paging.limits);
        _this.baseModel = {
          orders: response.data.orders,
          numberOfOrders: response.data.total_number,
          numberOfPages: Math.ceil(response.data.total_number / _this.formSearch.paging.limits)
        };
        _this.formSearch.paging.currentPage = _this.formSearch.paging.askedPage + 1;
        if (!_this.formSearch.paging.currentPage) {
          _this.formSearch.paging.currentPage = 0;
        }

        //We prepare for delivery address expand
        _this.baseModel.orders = _this.baseModel.orders.map(function (order) {
          return _objectSpread(_objectSpread({}, order), {}, {
            isOrderExpanded: false
          });
        });
        _this.dataLoading = false;
        _this.$EventBus.$emit("loading", false);
      });
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.baseModel.numberOfPages) {
        this.formSearch.paging.askedPage = askedPage;
        this.search();
      }
    },
    orderDetails: function orderDetails(order) {
      if (order.user.id_user === +this.loggedUserData.idUser) {
        return {
          name: "userOrderSummary",
          params: {
            id: order.id_order
          }
        };
      } else {
        return {
          name: "consultantOrderDetails",
          params: {
            id: order.id_order
          }
        };
      }
    },
    importOrder: function importOrder() {
      this.isImportOrderShown = true;
    },
    rowClick: function rowClick(order) {
      var routeData = this.orderDetails(order);
      this.$router.push(routeData);
    },
    rowClickContextMenu: function rowClickContextMenu(mouseEvent, event) {
      mouseEvent.preventDefault();
      var contextItems = [{
        type: "routerLinkBlank",
        text: "Open in a new tab",
        class: "router-link --no-hover-underlined",
        routeData: this.orderDetails(event.item)
      }];
      var position = {
        x: mouseEvent.x,
        y: mouseEvent.y
      };
      this.$refs.contextMenu.openMenu(event.item, contextItems, position);
    },
    isEtaAvailable: function isEtaAvailable(order) {
      return order.expedition_method !== 0 && order.expedition_method !== expeditionMethods.CELLAR_STORAGE.id && order.etaMinHours > 0 && order.etaMaxHours > 0;
    },
    getEtaLabel: function getEtaLabel(eta_min_hours, eta_max_hours) {
      var unit = eta_min_hours > 72 || eta_max_hours && eta_max_hours > 72 ? "days" : "hours";
      if (unit === "days") {
        return Math.ceil(eta_min_hours / 24) + (eta_max_hours ? "-" + Math.ceil(eta_max_hours / 24) : "") + " " + unit;
      } else {
        return eta_min_hours + (eta_max_hours ? "-" + eta_max_hours : "") + " " + unit;
      }
    },
    hasBeenValidated: function hasBeenValidated(order) {
      return !orderStatus.filter(function (x) {
        return ["AWAITING_CUSTOMER_VALIDATION", "AWAITING_VALIDATION", "ADJUSTING"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(order.status);
    },
    getOrderStatusClass: function getOrderStatusClass(order) {
      if (orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "AWAITING_CUSTOMER_VALIDATION" || orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "AWAITING_VALIDATION" || orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "ADJUSTING") {
        return "neutral";
      }
      if (orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "ON_HOLD" || orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "CANCELLED") {
        return "danger";
      }
      if (orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "DELIVERED" || orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "INBOUND" || orderStatus.find(function (x) {
        return x.status == order.status;
      }).id === "SUBCONTAINER_PUT_INBOUND") {
        return "success";
      }
      return "info";
    },
    getShipmentMethodIcon: function getShipmentMethodIcon(order) {
      var expeditionMethod = this.expeditionMethodList.filter(function (x) {
        return x.id === order.expedition_method;
      });
      if (expeditionMethod.length) return expeditionMethod[0].faIcon;
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this3 = this;
      this.isCopyingToClipboard = true;
      setTimeout(function () {
        _this3.isCopyingToClipboard = false;
      }, 1000);
      return navigator.clipboard.writeText(text);
    },
    getOrderStatusIcon: getOrderStatusIcon,
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice,
    userGroupName: userGroupName,
    getFullNameUserHtml: getFullNameUserHtml,
    getOrderConfirmationReference: getOrderConfirmationReference,
    isHolding: isHolding
  }
};